import React, { Component } from 'react';
import MovieItem from './MovieItem/MovieItem';
import { Link } from 'react-router-dom';
import './PersonFilmography.scss';

class PersonFilmography extends Component {
  render() {
    let cast = Object.values(this.props).map(el => {
      return (
        <Link
          key={el.id}
          className="filmography-link"
          to={`/${el.type.toLowerCase()}/${el.id}`}>
          <MovieItem {...el} />
        </Link>
      );
    });

    return (
      <div className="filmography">
        <h2 className="filmography-title">Filmography</h2>
        {cast}
      </div>
    );
  }
}

export default PersonFilmography;
